import {createSelector} from '@ngrx/store';
import {UserSettings} from '../../global/user-settings.dto';
import {UserSettingsActionTypes} from '../actions/user.actions';

/**
 * reducer for the user
 * @param state 
 * @param action 
 */
export function addUserSettingsReducer(state:UserSettings, action: { type: string, payload:  {user_settings:UserSettings} }) {
    const payload = action.payload;
    switch (action.type) {
        case UserSettingsActionTypes.UPDATE_USER_SETTINGS:
            return { ...state, ...{user_settings: payload} };
        case UserSettingsActionTypes.CLEAR_STATE:
            return { ...state, ...{user_settings: null} };       
        default:
            return state;
    }
}

export const selectUserState = (state) => state.user_settings;
export const selectUser = createSelector(selectUserState, (state) => state);
export const selectUserSetting = createSelector(selectUserState, (state) => state?.user_settings);
export const currentUserId = createSelector(selectUserState, (state) => state?.user_settings?.id);
export const isAddonPermissionDefined = createSelector(
  selectUserState,
  (state) => {
    if (!state?.user_settings?.workspaces) return false;

    const defaultWs = state.user_settings.workspaces.find(ws => ws?.default === true);
    if (!defaultWs) return false;

    return Object.prototype.hasOwnProperty.call(defaultWs, 'addon_setting');
  }
);
export const hasAddonPermission = (addonKey: string) => createSelector(selectUserState, (state) => {
    return state?.user_settings?.workspaces?.find(x => x?.default === true)?.addon_setting?.some(x => x.key === addonKey && x.active )
});
export const getCCFilters = (key: string) => createSelector(selectUserState, (state) => {
    return state?.user_settings?.contract_control_setting?.find(x => x?.key === key);
});
export const userName = createSelector((selectUserState), state=> state?.user_settings?.name || '')
export const userId = createSelector((selectUserState), state=> state?.user_settings?.id || '')
export const defaultWorkSpace = createSelector(selectUserState, state => state.user_settings?.workspaces.find(x => x.default === true));
